// Single source of truth for the eight Regal Worlds.
// Edit titles, descriptors, intros, greetings, icons and availability here only.
import { Gem, Heart, Landmark, Diamond, Sparkles, PenTool, Scale } from "lucide-react";
import { RegalCrown } from "../components/RegalCrown";

export const REGAL_WORLDS = [
  {
    slug: "gold-world",
    title: "Gold World",
    icon: RegalCrown,
    descriptor: "22K and 24K gold — bangles, chains, rings and sets.",
    intro: "The heart of the house — gold jewelry crafted to be worn, kept and passed on.",
    greeting: "Welcome to Gold World. Here, gold is not simply worn — it is treasured.",
    photoFilter: { category: "gold", type: "bangles" },
    pose: "goldbar",
    available: true,
  },
  {
    slug: "diamond-world",
    title: "Diamond World",
    icon: Gem,
    descriptor: "Diamond jewelry selected for brilliance and character.",
    intro: "A world devoted to diamonds and the light they carry.",
    greeting: "Welcome to Diamond World. Every diamond carries its own light. Let us find yours.",
    photoFilter: { category: "diamond", type: "rings" },
    pose: "loupe",
    available: true,
  },
  {
    slug: "bridal-world",
    title: "Bridal World",
    icon: Heart,
    descriptor: "Jewelry for weddings, engagements and new beginnings.",
    intro: "Pieces chosen for the most important days of your life.",
    greeting: "Welcome to Bridal World. For the days when every promise turns to gold.",
    photoFilter: { type: "sets", search: "bridal" },
    pose: "necklace",
    available: true,
  },
  {
    slug: "heritage-jewelry",
    title: "Heritage Jewelry",
    icon: Landmark,
    descriptor: "Designs rooted in tradition and family memory.",
    intro: "Jewelry that honors where you come from.",
    greeting: "Welcome to Heritage Jewelry. Some pieces are not bought — they are inherited.",
    photoFilter: { search: "temple" },
    pose: "display",
    available: true,
  },
  {
    slug: "precious-stones",
    title: "Precious Stones",
    icon: Diamond,
    descriptor: "Color, rarity and meaning — stone-set jewelry.",
    intro: "A world of color and rarity, set in gold.",
    greeting: "Welcome to Precious Stones. Color, rarity and meaning, set in gold.",
    photoFilter: { search: "ruby" },
    pose: "gemstone",
    available: true,
  },
  {
    slug: "silver-spiritual",
    title: "Silver & Spiritual Collection",
    icon: Sparkles,
    descriptor: "Silver pieces and jewelry of faith and devotion.",
    intro: "Silver and spiritual jewelry for everyday meaning.",
    greeting: "Welcome to the Silver and Spiritual Collection. Jewelry for faith, devotion and everyday grace.",
    photoFilter: { category: "silver", search: "om " },
    pose: "diya",
    available: true,
  },
  {
    slug: "custom-design-studio",
    title: "Custom Design Studio",
    icon: PenTool,
    descriptor: "Bring your own design to life with our jewelers.",
    intro: "Where an idea becomes a piece made only for you.",
    greeting: "Welcome to the Custom Design Studio. Tell me what you dream of, and we will craft it.",
    photoFilter: { category: "gold", type: "rings" },
    pose: "sketch",
    available: true,
  },
  {
    slug: "gold-exchange-services",
    title: "Gold Exchange & Services",
    icon: Scale,
    descriptor: "Exchange, appraisal and in-store services.",
    intro: "A dedicated space for gold exchange and services.",
    greeting: "Welcome to Gold Exchange and Services. Bring your gold — it will be treated with respect.",
    photoFilter: { category: "bullion" },
    pose: "examine",
    available: true,
  },
];
